import { createSelector } from 'reselect';
import { smartSkinScanBannerSelector } from 'selectors/testTarget/offers/smartSkinScanBanner/smartSkinScanBannerSelector';

const enabledSelector = createSelector(smartSkinScanBannerSelector, smartSkinScanBanner => smartSkinScanBanner.enabled);

export { enabledSelector };
